import React, { useEffect, useState } from 'react'
import { useChat } from '../hooks/useChat'
import { MessageList } from './MessageList'
import { MessageInput } from './MessageInput'

interface EmbeddedChatWindowProps {
  agentId: string
  onResize?: (dimensions: { width: number; height: number }) => void
}

export const EmbeddedChatWindow: React.FC<EmbeddedChatWindowProps> = ({
  agentId,
  onResize
}) => {
  const [input, setInput] = useState('')
  const { messages, isLoading, sendMessage, endConversation } = useChat(agentId)

  useEffect(() => {
    // Notify parent of size changes
    onResize?.({ width: 400, height: 600 })
  }, [onResize])

  const handleSend = () => {
    if (input.trim() && !isLoading) {
      sendMessage(input.trim())
      setInput('')
    }
  }

  return (
    <div style={{
      width: '100%',
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: 'white'
    }}>
      <div style={{
        flex: 1,
        overflowY: 'auto',
        padding: '16px',
        backgroundColor: '#f9fafb'
      }}>
        <MessageList 
          messages={messages}
          primaryColor="#3b82f6"
          isLoading={isLoading}
          onEndConversation={endConversation}
        />
      </div>

      <MessageInput
        value={input}
        onChange={setInput}
        onSend={handleSend}
        isLoading={isLoading}
        placeholder="Type your message..."
        primaryColor="#3b82f6"
        voiceEnabled={true}
      />
    </div>
  )
}